import { render } from "./ExpenseGrid.vue?vue&type=template&id=0f87d882"
import script from "./ExpenseGrid.vue?vue&type=script&lang=js"
export * from "./ExpenseGrid.vue?vue&type=script&lang=js"

import "./ExpenseGrid.vue?vue&type=style&index=0&id=0f87d882&lang=css"

import exportComponent from "/var/www/karman/karman_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__